import { createMandatoryContext } from '@change-corgi/core/react/context';

import type { ReportContext } from '../types';

export const {
	Context: PetitionReportAbuseContext,
	Provider: PetitionReportAbuseContextProvider,
	useContext: usePetitionReportAbuseContext,
} = createMandatoryContext<ReportContext>(undefined, {
	name: 'PetitionReportAbuseContext',
});
